import { render, staticRenderFns } from "./uf_prioriti_complect_auto.vue?vue&type=template&id=53886b85&scoped=true"
import script from "./uf_prioriti_complect_auto.vue?vue&type=script&lang=js"
export * from "./uf_prioriti_complect_auto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53886b85",
  null
  
)

export default component.exports